import { render, staticRenderFns } from "./UnusedDays.vue?vue&type=template&id=2157eaa5&"
import script from "./UnusedDays.vue?vue&type=script&lang=js&"
export * from "./UnusedDays.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports